import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, setPropTypes, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import CommonButtonId from '../../components/atoms/CommonButtonId';

const styles = {
  root: {
    marginTop: 15
  },
  overflow: {
    overflow: 'auto'
  },
  buttonContainer: {
    padding: '10px 26px 10px 26px',
    textAlign: 'right',
    backgroundColor: '#fff'
  },
  button: {
    margin: '5px 5px'
  },
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(dispatch => ({
    actions: bindActionCreators({}, dispatch)
  })),
  setPropTypes(propTypes),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(({ classes, ticketInfo, handleConfirmRefund }) => {
  return (
    <div className={classes.root}>
      <div className={classes.scrollTable}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>user_name</TableCell>
              <TableCell>Shop_id</TableCell>
              <TableCell>shop_name</TableCell>
              <TableCell>menu_id</TableCell>
              <TableCell>Menu_name</TableCell>
              <TableCell>User_email</TableCell>
              <TableCell>Used_ticket_number</TableCell>
              <TableCell>Used_price</TableCell>
              <TableCell>Charge_amount</TableCell>
              <TableCell>Payment_type</TableCell>
              <TableCell>Used_time</TableCell>
              <TableCell>Button Refund (返金)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {ticketInfo &&
              ticketInfo.map(ticket => (
                <TableRow>
                  <TableCell>{ticket.userName}</TableCell>
                  <TableCell>{ticket.shopId}</TableCell>
                  <TableCell>{ticket.shopName}</TableCell>
                  <TableCell>{ticket.menuId}</TableCell>
                  <TableCell>{ticket.menuName}</TableCell>
                  <TableCell>{ticket.userEmail}</TableCell>
                  <TableCell>{ticket.usedTicketNumber}</TableCell>
                  <TableCell>{ticket.usedPrice}</TableCell>
                  <TableCell>{ticket.chargeAmount}</TableCell>
                  <TableCell>{ticket.paymentType}</TableCell>
                  <TableCell>{ticket.usedAt}</TableCell>
                  <TableCell>
                    <CommonButtonId
                      className={classes.button}
                      title="返金"
                      disabled={!ticket.chargeAmount}
                      onClickAction={() =>
                        handleConfirmRefund(
                          ticket.chargeAmount,
                          ticket.merchantPaymentId
                        )
                      }
                    />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
});

export default withRouter(withStyles(styles)(Main));
